import '@client-side-validations/client-side-validations'
import '@client-side-validations/simple-form'

ClientSideValidations.formBuilders['SimpleForm::FormBuilder'].wrappers["default"] = {
    add: function(element, settings, message) {
        const wrapperElement = element.closest(settings.wrapper_tag + "." + (settings.wrapper_class.replace(/\ /g, '.')));
        let errorElement = wrapperElement.find(settings.error_tag + ".invalid-feedback");
        if (!errorElement.length) {
            errorElement = $("<" + settings.error_tag + "/>", {
                "class": 'invalid-feedback',
                text: message
            });
            wrapperElement.append(errorElement);
        }
        wrapperElement.addClass(settings.wrapper_error_class);
        element.addClass('is-invalid');
        return errorElement.text(message);
    },
    remove: function(element, settings) {
        const wrapperElement = element.closest(settings.wrapper_tag + "." + (settings.wrapper_class.replace(/\ /g, '.')) + "." + settings.wrapper_error_class);
        const errorElement = wrapperElement.find(settings.error_tag + ".invalid-feedback");
        wrapperElement.removeClass(settings.wrapper_error_class);
        element.removeClass('is-invalid');
        return errorElement.remove();
    }
};

ClientSideValidations.formBuilders['SimpleForm::FormBuilder'].wrappers.horizontal_form = {
    add: function(element, settings, message) {
        const wrapperElement = element.closest(settings.wrapper_tag + ".col-sm-9");
        let errorElement = wrapperElement.find(settings.error_tag + ".invalid-feedback");
        if (!errorElement.length) {
            errorElement = $("<" + settings.error_tag + "/>", {
                "class": 'invalid-feedback',
                text: message
            });
            wrapperElement.append(errorElement);
        }
        wrapperElement.addClass(settings.wrapper_error_class);
        element.addClass('is-invalid');
        return errorElement.text(message);
    },
    remove: function(element, settings) {
        let errorElement, wrapperElement;
        wrapperElement = element.closest(settings.wrapper_tag + ".col-sm-9." + settings.wrapper_error_class);
        errorElement = wrapperElement.find(settings.error_tag + ".invalid-feedback");
        element.removeClass('is-invalid');
        if (!wrapperElement.find('.is-invalid').length) {
            wrapperElement.removeClass(settings.wrapper_error_class);
            return errorElement.remove();
        }
    }
};

ClientSideValidations.selectors.validate_inputs += ', .select2-container:visible + :enabled[data-validate]';

ClientSideValidations.selectors.inputs += ', .select2-container:visible + :enabled[data-validate]';

$(document).on('turbolinks:load', function() {

    $("[data-multi-select='true']").each( (index, input) => {
        const $input = $(input);
        const $form = $input.closest('form');
        const targetValidator = $form[0].ClientSideValidations.settings.validators[$input.data('target-field')];
        return $form[0].ClientSideValidations.settings.validators[$input.attr("name")] = targetValidator;
    });

    $("[data-autocomplete='true']").each( (index, input) => {
        const $input = $(input);
        const $form = $input.closest('form');
        const targetValidator = $form[0].ClientSideValidations.settings.validators[$input.data('target-field')];
        return $form[0].ClientSideValidations.settings.validators[$input.attr("name")] = targetValidator;
    });
});